<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
      <!-- app-barに表示するボタン -->
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn class="ml-auto mr-2" color="primary" dense>
					<v-icon class="mr-2">mdi-pencil</v-icon>
					編集する</v-btn
				>
				<TemplateDeleteDialog :openBtnColor="'primary'" />
			</template>
			<v-sheet elevation="0">
      <!-- app-bar下に表示するボタン -->
				<v-row v-if="$vuetify.breakpoint.xs" no-gutters justify="end">
					<v-btn class="ml-auto mr-2" color="secondary" dense>
						<v-icon class="mr-2">mdi-pencil</v-icon>
						編集する</v-btn
					>
					<TemplateDeleteDialog />
				</v-row>
				<v-sheet elevation="0" class="mt-4">
					<v-row no-gutters>
						<!-- 2カラム表示用のブロック -->
						<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pr-2' : ''" cols="12" md="6">
							<!-- 中項目を含むブロック -->
							<v-row no-gutters class="px-1 pt-2 show-unit">
								<v-col cols="12" sm="3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
									<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">中項目名</h4>
								</v-col>
								<v-col cols="12" sm="9">
									<!-- 項目名とテキストのブロック -->
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h5 class="text-body-1 font-weight-bold">項目名</h5>
										</v-col>
										<v-col cols="8">
											<p class="text-body-1">テキスト</p>
										</v-col>
									</v-row>
									<!-- 項目名とテキストのブロック ここまで-->
								</v-col>
							</v-row>
							<!-- 中項目を含むブロック ここまで-->
							<v-row no-gutters class="px-1 pt-2 show-unit">
								<v-col cols="12" sm="3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
									<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">中項目名</h4>
								</v-col>
								<v-col cols="12" sm="9">
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h5 class="text-body-1 font-weight-bold">項目名</h5>
										</v-col>
										<v-col cols="8">
											<p class="text-body-1">テキスト</p>
										</v-col>
									</v-row>
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h4 class="text-body-1 font-weight-bold">項目名</h4>
										</v-col>
										<v-col cols="8">
											<h4 class="text-body-1">テキスト</h4>
										</v-col>
									</v-row>
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h4 class="text-body-1 font-weight-bold">項目名</h4>
										</v-col>
										<v-col cols="8">
											<h4 class="text-body-1">テキスト</h4>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
						<!-- 2カラム表示用のブロック ここまで-->

						<!-- スマホ画面で表示するdivider -->
						<v-col v-if="!$vuetify.breakpoint.mdAndUp" cols="12">
							<v-divider />
						</v-col>

						<!-- ここから上と同じ -->
						<v-col :class="$vuetify.breakpoint.mdAndUp ? 'pl-2' : ''" cols="12" md="6">
							<v-row no-gutters class="px-1 pt-2 show-unit">
								<v-col cols="12" sm="3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
									<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">中項目名</h4>
								</v-col>
								<v-col cols="12" sm="9">
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h5 class="text-body-1 font-weight-bold">項目名</h5>
										</v-col>
										<v-col cols="8">
											<p class="text-body-1">テキスト</p>
										</v-col>
									</v-row>
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h4 class="text-body-1 font-weight-bold">項目名</h4>
										</v-col>
										<v-col cols="8">
											<h4 class="text-body-1">テキスト</h4>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row no-gutters class="px-1 pt-2 show-unit">
								<v-col cols="12" sm="3" :class="$vuetify.breakpoint.sm ? '' : 'pb-2'">
									<h4 class="text-sm-body-1 text-h6 font-weight-bold color-secondary">中項目名</h4>
								</v-col>
								<v-col cols="12" sm="9">
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h5 class="text-body-1 font-weight-bold">項目名</h5>
										</v-col>
										<v-col cols="8">
											<p class="text-body-1">テキスト</p>
										</v-col>
									</v-row>
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h4 class="text-body-1 font-weight-bold">項目名</h4>
										</v-col>
										<v-col cols="8">
											<h4 class="text-body-1">テキスト</h4>
										</v-col>
									</v-row>
									<v-row no-gutters class="pb-2 show-detail-unit">
										<v-col cols="4">
											<h4 class="text-body-1 font-weight-bold">項目名</h4>
										</v-col>
										<v-col cols="8">
											<h4 class="text-body-1">テキスト</h4>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-sheet>
			</v-sheet>
		</CommonFlame>
	</v-sheet>
</template>
<script>
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import TemplateDeleteDialog from "../shared/TemplateDeleteDialog.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		TemplateDeleteDialog,
	},
	data() {
		return {
			mainTitle: "部門名・項目名",
			pageTitle: "SampleShowPage.vue",
		}
	},
	methods: {
		showDialog(item) {
			this.selectedItem = item
		},
	},
	computed: {
		items() {
			const array = []
			for (let i = 0; i < 50; i++) {
				array.push({
					text1: `テキスト${i}-1`,
					text2: `テキスト${i}-2`,
					text3: `テキスト${i}-3`,
					text4: `テキスト${i}-4`,
					text5: `テキスト${i}-5`,
					text6: `テキスト${i}-6`,
					text7: `テキスト${i}-7`,
					text8: `テキスト${i}-8`,
				})
			}
			return array
		},
	},
}
</script>